__turbopack_context__.v({
  "blockTitle": "NewsBlock-module-scss-module__t3Kq9G__blockTitle",
  "blockTitleContainerClassName": "NewsBlock-module-scss-module__t3Kq9G__blockTitleContainerClassName",
  "blocksBackgroundColor": "NewsBlock-module-scss-module__t3Kq9G__blocksBackgroundColor",
  "blocksFontColor": "NewsBlock-module-scss-module__t3Kq9G__blocksFontColor",
  "editButton": "NewsBlock-module-scss-module__t3Kq9G__editButton",
  "editDropDown": "NewsBlock-module-scss-module__t3Kq9G__editDropDown",
  "editableTitle": "NewsBlock-module-scss-module__t3Kq9G__editableTitle",
  "editableTitleParent": "NewsBlock-module-scss-module__t3Kq9G__editableTitleParent",
  "newsBlockContainer": "NewsBlock-module-scss-module__t3Kq9G__newsBlockContainer",
  "noContent": "NewsBlock-module-scss-module__t3Kq9G__noContent",
  "secondaryNavBackgroundColor": "NewsBlock-module-scss-module__t3Kq9G__secondaryNavBackgroundColor",
  "themeBackgroundColor": "NewsBlock-module-scss-module__t3Kq9G__themeBackgroundColor",
  "themeFontColor": "NewsBlock-module-scss-module__t3Kq9G__themeFontColor",
  "themeFontFamily": "NewsBlock-module-scss-module__t3Kq9G__themeFontFamily",
  "titleAndEditPencil": "NewsBlock-module-scss-module__t3Kq9G__titleAndEditPencil",
  "titleContainer": "NewsBlock-module-scss-module__t3Kq9G__titleContainer",
  "toggleClassName": "NewsBlock-module-scss-module__t3Kq9G__toggleClassName",
  "viewMoreButton": "NewsBlock-module-scss-module__t3Kq9G__viewMoreButton",
});
